
import { Options, Vue } from "vue-class-component";
import type { PropType } from "vue";
import { NOOP } from "@vue/shared";
import { ComputerActionTypes } from "@/store/modules/computer/action-types";
import { pageNavList } from "@/constant/options";
import { useStore } from "@/store";
import {
  pageConfig,
  PageClassifyNav,
  PageCourseGroup,
  PageRichText,
  PageArticle,
  PageDataDisplay,
} from "@/constant/computerType";

@Options({
  props: {
    componentIndex: {
      type: Number,
      default: 0,
    },
    updatePageIndx: {
      type: Function as PropType<void>,
      default: NOOP,
    },
  },
})
export default class pageSide extends Vue {
  updatePageIndx!: Function;
  componentIndex: number = 0;
  private store = useStore();
  private pageNavList: { value: string; label: string; }[] = pageNavList;
  private isCollapse: boolean = true;
  private imgPageConfig: pageConfig = {
    addable: false,
    deleteable: false,
    dragable: false,
    editable: false,
    help_href: "",
    id: '',
    is_modified: true,
    order_weight: 0,
    sub_list: [],
    title: "",
    type: "",
    type_title: "",
  };
  private pageClassifyNav: PageClassifyNav = {
    ...this.imgPageConfig,
    row_num: 3,
    show_title: true,
    sub_list: [{
      img_url: '',
      link_id: '1',
      link_title: '',
      link_type: '',
      link_url: '',
      link_target: '',
      fileid: '',
      title: '分类1',
      type: '',
    }, {
      img_url: '',
      link_id: '2',
      link_title: '',
      link_type: '',
      link_url: '',
      link_target: '',
      fileid: '',
      title: '分类2',
      type: '',
    }, {
      img_url: '',
      link_id: '3',
      link_title: '',
      link_type: '',
      link_url: '',
      link_target: '',
      fileid: '',
      title: '分类3',
      type: '',
    }
    ]
  };
  private pageCourseGroup: PageCourseGroup = {
    ...this.imgPageConfig,
    show_type: true,
    show_mobile_type: true,
    show_title: true,
    show_more: true,
    card_num: 5,
    tab_type_list: [
      {
        type_id: '',
        type_title: '类型',
        show_title: true,
        tag_list: [
          {
            link_id: '',
            link_url: '',
            link_title: '类型分类',
            link_type: 'course',
            title: '分类',
            type: '',
            classify_id: '',
            course_list: []
          }
        ],
        all_course: [],
        show_type: 0
      }
    ],
    more_link: {
      img_url: '',
      link_id: '1',
      link_title: '查看全部跳转',
      link_type: 'default',
      link_url: '',
      link_target: '',
      fileid: '',
      title: '',
      type: '',
    }
  };
  private pageRichText: PageRichText = {
    ...this.imgPageConfig,
    text: "",
  };

  private pageArticle: PageArticle = {
    ...this.imgPageConfig,
    show_title: true,
    show_more: true,
    module_num: 2,
    module_list: [
      {
        _id: '',
        show_type: 3,
        sub_list: [],
        pic_data: []
      },
      {
        _id: '',
        show_type: 1,
        sub_list: [],
        pic_data: []
      }
    ],
    more_link: {
      img_url: '',
      link_id: '1',
      link_title: '查看全部',
      link_type: 'default',
      link_url: '',
      link_target: '',
      fileid: '',
      title: '',
      type: '',
    }
  }

  readonly pageDataDisplay: PageDataDisplay = {
    ...this.imgPageConfig,
    show_title: true,
    background_color: '#ffffff',
    background_image: '',
    module_list: [['', '']],
  }

  get pageDataList() {
    return this.store.state.computer.pageDesignConfig;
  }

  created(): void {
  }

  setPageNavIcon(type: string) {
    switch (type) {
      case "pc_slideshow":
        return "icon-leaveform_outline";
      case "pc_classify":
        return "icon-listcard_outline";
      case "pc_course":
        return "icon-telephone_directory_outline";
      case "pc_richText":
        return "icon-tiankong_outline";
      case "pc_article":
        return "icon-wenzhang";
      case "pc_dataDisplay":
        return "icon-a-bianzu9";
    }
  }

  addPageItem(type: string) {
    let data: Array<pageConfig | PageClassifyNav | PageCourseGroup | PageRichText> = JSON.parse(JSON.stringify(this.pageDataList));
    let { imgPageConfig, pageClassifyNav, pageCourseGroup, pageRichText, componentIndex, pageArticle, pageDataDisplay, store } = this;

    const date = Date.now();

    if (type === "pc_slideshow") {
      imgPageConfig.title = '轮播图'
      imgPageConfig.type_title = '轮播图'
      imgPageConfig.type = type
      imgPageConfig.id = String(date)
      data.splice((componentIndex + 1), 0, imgPageConfig);
    } else if (type === "pc_classify") {
      pageClassifyNav.title = '分类导航'
      pageClassifyNav.type_title = '分类导航'
      pageClassifyNav.type = type
      pageClassifyNav.id = String(date)
      data.splice((componentIndex + 1), 0, pageClassifyNav);
    } else if (type === "pc_course") {
      pageCourseGroup.title = '课程'
      pageCourseGroup.type_title = '课程分组'
      pageCourseGroup.type = type
      pageCourseGroup.id = String(date)
      pageCourseGroup.tab_type_list[0].type_id = String(date + 1);
      pageCourseGroup.tab_type_list[0].tag_list[0].classify_id = String(date + 2);
      data.splice((componentIndex + 1), 0, pageCourseGroup);
    } else if (type === "pc_richText") {
      pageRichText.title = '富文本'
      pageRichText.type_title = '富文本'
      pageRichText.type = type
      pageRichText.text = ''
      pageRichText.id = String(date)
      data.splice((componentIndex + 1), 0, pageRichText);
    } else if (type === 'pc_article') {
      pageArticle.title = '新闻通知'
      pageArticle.type_title = '文章'
      pageArticle.type = type
      pageArticle.id = String(date);
      pageArticle.module_list[0]._id = String(date + 1)
      pageArticle.module_list[1]._id = String(date + 2)
      data.splice((componentIndex + 1), 0, pageArticle);
    } else if(type === 'pc_dataDisplay') {
      pageDataDisplay.title = '平台数据'
      pageDataDisplay.type_title = '数据展示'
      pageDataDisplay.type = type;
      pageDataDisplay.id = String(date);
      data.splice((componentIndex + 1), 0, pageDataDisplay);
    }

    setTimeout(() => {
      document.querySelectorAll('.main-content .card-box')[componentIndex + 1].scrollIntoView({ behavior: 'smooth', block: 'center' });
    })

    store.dispatch(ComputerActionTypes.ACTION_PC_MODIFY_PAGE_CONFIG, data);
    this.updatePageIndx(this.componentIndex)
  }
}
